import React from 'react';

import {VersionsSidebarFactory} from 'app/components/general/VersionsSidebar';
import {useInfiniteListFetcherRTK} from 'app/general/datafetchers/hooks/useInfiniteListFetcherRTK';
import {
  convertLocationParamsToFetchParams,
  useQuizVersions,
} from 'app/quizzes/api';
import {SORT_BY_TYPES} from 'app/utils/constants';

import type {SpecificVersionsSidebarOwnProps} from 'app/components/general/VersionsSidebar';
import type {DocumentContentType, QuizVersionSerializedType} from 'sweet-types';

export const QuizVersionsSidebar = ({
  canDelete,
  selectedVersion,
  closeSidebar,
  objectId,
  collapsed,
  onToggleCollapsed,
}: SpecificVersionsSidebarOwnProps) => {
  const {
    results: versions,
    refetch,
    loadNext,
    hasNext,
  } = useInfiniteListFetcherRTK({
    fetchParams: {
      quizId: objectId,
      ordering: SORT_BY_TYPES.CREATION_DATE,
    },
    useDataHook: useQuizVersions,
    paramsConverter: convertLocationParamsToFetchParams,
  });

  const contentType: DocumentContentType = 'quiz';

  const params = {
    canDelete,
    collapsed,
    selectedVersion,
    closeSidebar,
    objectId,
    onToggleCollapsed,
    loadVersions: async () => refetch(),
    loadMoreVersions: async () => loadNext(),
    contentType,
    moreToLoad: hasNext,
    versions: versions,
  };

  return <VersionsSidebarComponent {...params} />;
};

const VersionsSidebarComponent =
  VersionsSidebarFactory<QuizVersionSerializedType>();
